// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uploadedData table {
  border-collapse: separate;
  border-spacing: 3px 15px;
}
.uploadedData table tr {
  margin: 0;
  padding: 0;
  display: table-row;
}
.uploadedData table tr:hover {
  background: transparent !important;
}
.uploadedData table td {
  font-size: 14px;
  border: none !important;
  padding: 8px 8px;
  font-weight: 400;
  display: table-cell;
}
.uploadedData table td button {
  padding: 6px 10px;
  border-radius: 10px;
}
.uploadedData table th {
  font-size: 14px;
  color: #01393f;
  border: none !important;
  padding: 12px 8px;
  display: table-cell;
  font-weight: 700;
}
.uploadedData table tbody {
  margin: 0 !important;
  display: table-row-group;
}
.uploadedData table tbody tr {
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
  margin: 5px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.4);
}
.uploadedData table tbody tr td:first-child {
  font-weight: 600;
}
.uploadedData table tbody tr:hover {
  background-color: rgba(6, 180, 200, 0.08) !important;
}

.graphSelectBox {
  max-width: 110px;
  text-align: left;
  margin-right: 0 !important;
  margin-left: auto !important;
}
.graphSelectBox .MuiSelect-select {
  padding: 8px 15px;
}

.mapViewBtn {
  display: inline-flex;
  align-items: center;
  border-radius: 5px;
  overflow: hidden;
  margin-top: 8px;
  margin-left: 8px;
}
.mapViewBtn button {
  height: 28px;
  border: 1px solid #bbb;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0;
  background: #fff;
  font-size: 12px;
  text-transform: capitalize;
  z-index: 1;
  font-weight: 700;
}
.mapViewBtn button:hover, .mapViewBtn button:active {
  background-color: #fff !important;
  color: #212529 !important;
}
.mapViewBtn button.activeMap {
  background-color: #42db89 !important;
  color: #fff !important;
}

.dropdown {
  background-color: #fff;
  height: 28px;
  border: 1px solid #bbb;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0;
  border-radius: 5px;
}
.dropdown .btn:focus {
  box-shadow: none;
}

.mentItem {
  display: flex;
  gap: 5px;
  align-items: center;
  text-decoration: none !important;
  text-transform: none !important;
  color: #000;
}
.mentItem:hover {
  color: #000 !important;
}
.mentItem h1 {
  font-size: 15px !important;
  text-transform: capitalize;
  font-weight: 400;
  align-items: center;
  margin-bottom: 0px !important;
}

.dropdown-menu {
  background-color: #fff;
  box-sizing: content-box;
  padding: 10px !important;
  min-width: 0px !important;
  margin: 0px !important;
  right: 0 !important;
  width: 156px;
}
.dropdown-menu ul {
  padding: 0 !important;
}
.dropdown-menu ul li::marker {
  content: "";
}

.treeNode__main {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
}
.treeNode__Details {
  display: flex;
  gap: 10px;
}

.childNode .treeNode__main {
  padding-left: 25px;
}

.mapAllBtns {
  display: flex !important;
  align-items: end;
  grid-gap: 4px;
  gap: 0;
  flex-direction: column;
  padding: 10px;
  position: absolute !important;
  right: 0;
  bottom: 0;
  top: 0;
  justify-content: space-between;
  width: 0;
}
.mapAllBtns .iconBtn {
  height: 28px;
  width: 28px;
  border: 1px solid #bbb;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
}
.mapAllBtns .iconBtn svg {
  height: 15px;
  width: 15px;
}

.mapZoomModel .modal-dialog {
  max-width: 90vw;
  height: 90vh;
}
.mapZoomModel .modal-dialog .modal-content {
  height: 100%;
  border-radius: 10px;
}
.mapZoomModel .modal-dialog .modal-header {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 11;
}
.mapZoomModel .modal-dialog .modal-header button {
  background: #fff;
  height: 32px;
  width: 32px;
  min-width: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  opacity: 1;
}
.mapZoomModel .modal-dialog .modal-header button span {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -5px;
}
.mapZoomModel .modal-dialog .modal-body {
  padding: 5px;
}
.mapZoomModel .modal-dialog .modal-body > div {
  width: 100% !important;
  height: 100% !important;
}

.detailsSidebar {
  position: sticky;
  top: 85px;
}`, "",{"version":3,"sources":["webpack://./src/views/authenticated/uploadImageToS3.scss"],"names":[],"mappings":"AACE;EACE,yBAAA;EACA,wBAAA;AAAJ;AAEI;EACE,SAAA;EACA,UAAA;EACA,kBAAA;AAAN;AACM;EACE,kCAAA;AACR;AAGI;EACE,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AADN;AAEM;EACE,iBAAA;EACA,mBAAA;AAAR;AAII;EACE,eAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAFN;AAKI;EACE,oBAAA;EACA,wBAAA;AAHN;AAIM;EACE,8CAAA;EACA,WAAA;EACA,mBAAA;EACA,oCAAA;AAFR;AAGQ;EACE,gBAAA;AADV;AAGQ;EACE,oDAAA;AADV;;AAOA;EACE,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,4BAAA;AAJF;AAKE;EACE,iBAAA;AAHJ;;AAOA;EACE,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAJF;AAKE;EACE,YAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,UAAA;EACA,gBAAA;AAHJ;AAII;EAEE,iCAAA;EACA,yBAAA;AAHN;AAKI;EACE,oCAAA;EACA,sBAAA;AAHN;;AAQA;EACE,sBAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AALF;AAQE;EACE,gBAAA;AANJ;;AAUA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,gCAAA;EACA,+BAAA;EACA,WAAA;AAPF;AAQE;EACE,sBAAA;AANJ;AASE;EACE,0BAAA;EACA,0BAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;AAPJ;;AAUA;EACE,sBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AAPF;AASE;EACE,qBAAA;AAPJ;AASM;EACE,WAAA;AAPR;;AAcE;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;AAXJ;AAcE;EACE,aAAA;EACA,SAAA;AAZJ;;AAiBI;EACE,kBAAA;AAdN;;AAmBA;EACE,wBAAA;EACA,gBAAA;EACA,aAAA;EACA,MAAA;EACA,sBAAA;EACA,aAAA;EACA,6BAAA;EACA,QAAA;EACA,SAAA;EACA,MAAA;EACA,8BAAA;EACA,QAAA;AAhBF;AAiBE;EACE,YAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAfJ;AAgBI;EACE,YAAA;EACA,WAAA;AAdN;;AAoBE;EACE,eAAA;EACA,YAAA;AAjBJ;AAkBI;EACE,YAAA;EACA,mBAAA;AAhBN;AAkBI;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;AAhBN;AAiBM;EACE,gBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,UAAA;AAfR;AAgBQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAdV;AAkBI;EACE,YAAA;AAhBN;AAiBM;EACE,sBAAA;EACA,uBAAA;AAfR;;AAqBA;EACE,gBAAA;EACA,SAAA;AAlBF","sourcesContent":[".uploadedData {\n  table {\n    border-collapse: separate;\n    border-spacing: 3px 15px;\n\n    tr {\n      margin: 0;\n      padding: 0;\n      display: table-row;\n      &:hover {\n        background: transparent !important;\n      }\n    }\n\n    td {\n      font-size: 14px;\n      border: none !important;\n      padding: 8px 8px;\n      font-weight: 400;\n      display: table-cell;\n      button {\n        padding: 6px 10px;\n        border-radius: 10px;\n      }\n    }\n\n    th {\n      font-size: 14px;\n      color: #01393f;\n      border: none !important;\n      padding: 12px 8px;\n      display: table-cell;\n      font-weight: 700;\n    }\n\n    tbody {\n      margin: 0 !important;\n      display: table-row-group;\n      tr {\n        box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);\n        margin: 5px;\n        border-radius: 10px;\n        background: #fff6;\n        td:first-child {\n          font-weight: 600;\n        }\n        &:hover {\n          background-color: rgb(6 180 200 / 8%) !important;\n        }\n      }\n    }\n  }\n}\n.graphSelectBox {\n  max-width: 110px;\n  text-align: left;\n  margin-right: 0 !important;\n  margin-left: auto !important;\n  .MuiSelect-select {\n    padding: 8px 15px;\n  }\n}\n\n.mapViewBtn {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 5px;\n  overflow: hidden;\n  margin-top: 8px;\n  margin-left: 8px;\n  button {\n    height: 28px;\n    border: 1px solid #bbb;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 0;\n    background: #fff;\n    font-size: 12px;\n    text-transform: capitalize;\n    z-index: 1;\n    font-weight: 700;\n    &:hover,\n    &:active {\n      background-color: #fff !important;\n      color: #212529 !important;\n    }\n    &.activeMap {\n      background-color: #42db89 !important;\n      color: #fff !important;\n    }\n  }\n}\n\n.dropdown {\n  background-color: #fff;\n  height: 28px;\n  border: 1px solid #bbb;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0;\n  border-radius: 5px;\n  // z-index: 2 !important;\n\n  .btn:focus {\n    box-shadow: none;\n  }\n}\n\n.mentItem {\n  display: flex;\n  gap: 5px;\n  align-items: center;\n  text-decoration: none !important;\n  text-transform: none !important;\n  color: #000;\n  &:hover {\n    color: #000 !important;\n  }\n\n  h1 {\n    font-size: 15px !important;\n    text-transform: capitalize;\n    font-weight: 400;\n    align-items: center;\n    margin-bottom: 0px !important;\n  }\n}\n.dropdown-menu {\n  background-color: #fff;\n  box-sizing: content-box;\n  padding: 10px !important;\n  min-width: 0px !important;\n  margin: 0px !important;\n  right: 0 !important;\n  width: 156px;\n\n  ul {\n    padding: 0 !important;\n    li {\n      &::marker {\n        content: \"\";\n      }\n    }\n  }\n}\n\n.treeNode {\n  &__main {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 10px;\n  }\n\n  &__Details {\n    display: flex;\n    gap: 10px;\n  }\n}\n.childNode {\n  .treeNode {\n    &__main {\n      padding-left: 25px;\n    }\n  }\n}\n\n.mapAllBtns {\n  display: flex !important;\n  align-items: end;\n  grid-gap: 4px;\n  gap: 0;\n  flex-direction: column;\n  padding: 10px;\n  position: absolute !important;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  justify-content: space-between;\n  width: 0;\n  .iconBtn {\n    height: 28px;\n    width: 28px;\n    border: 1px solid #bbb;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 5px;\n    svg {\n      height: 15px;\n      width: 15px;\n    }\n  }\n}\n\n.mapZoomModel {\n  .modal-dialog {\n    max-width: 90vw;\n    height: 90vh;\n    .modal-content {\n      height: 100%;\n      border-radius: 10px;\n    }\n    .modal-header {\n      position: absolute;\n      right: 0;\n      top: 0;\n      z-index: 11;\n      button {\n        background: #fff;\n        height: 32px;\n        width: 32px;\n        min-width: 32px;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin: 0;\n        opacity: 1;\n        span {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          margin-top: -5px;\n        }\n      }\n    }\n    .modal-body {\n      padding: 5px;\n      & > div {\n        width: 100% !important;\n        height: 100% !important;\n      }\n    }\n  }\n}\n\n.detailsSidebar {\n  position: sticky;\n  top: 85px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
